import { applyMiddleware, combineReducers, compose, legacy_createStore as createStore } from 'redux';
import thunk from 'redux-thunk';

import { State } from '../Types/State';

import { administrationReducer } from './Administration';
import { accountReducer } from './Account';
import { alertsReducer } from './Alerts/reducer';
import { businessReducer } from './Business/reducer';
import { contactsReducer } from './Contacts/reducer';
import { conversationsReducer } from './Conversations/reducer';
import { directoryReducer } from './Directory/reducer';
import { documentsReducer } from './Documents/reducer';
import { emergencyNewsItemsReducer } from './EmergencyNewsItems/reducer';
import { featureFlagsReducer } from './FeatureFlags/reducer';
import { globalMessageReducer } from './GlobalMessages/reducer';
import inspectionsAppReducer from './Inspections/App/reducer';
import inspectionsFeatureReducer from './Inspections/Feature/reducer';
import inspectionsPrintReducer from './Inspections/Print/reducer';
import { insuranceReducer } from './Insurance/reducer';
import { leasingReducer } from './Leasing/reducer';
import { listWrapperReducer } from './ListWrapper';
import { locationsReducer } from './Locations/reducer';
import mobileReducer from './Mobile/reducer';
import { notificationsReducer } from './Notifications/reducer';
import { occupantsReducer } from './Occupants/reducer';
import { paymentsReducer } from './Payments/reducer';
import { propertiesReducer } from './Properties/reducer';
import { propertyTenantResolutionReducer } from './PropertyTenantResolution/reducer';
import { requestsReducer } from './Requests/reducer';
import { salesReducer } from './Sales/reducer';
import { settingsReducer } from './Settings/reducer';
import { spacesReducer } from './Spaces/reducer';
import { toastMessageReducer } from './ToastMessages/reducer';
import { usersReducer } from './Users/reducer';
import { welcomeReducer } from './Welcome/reducer';
import { invoicesReducer } from './Invoices/reducer';

interface CompositionWindow extends Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
}

declare const window: CompositionWindow;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const rootReducer = combineReducers<State>({
    administration: administrationReducer,
    account: accountReducer,
    alerts: alertsReducer,
    business: businessReducer,
    contacts: contactsReducer,
    conversations: conversationsReducer,
    directory: directoryReducer,
    documents: documentsReducer,
    emergencyNewsItems: emergencyNewsItemsReducer,
    featureFlags: featureFlagsReducer,
    globalMessages: globalMessageReducer,
    inspectionsApplication: inspectionsAppReducer,
    inspectionsFeature: inspectionsFeatureReducer,
    inspectionsPrinter: inspectionsPrintReducer,
    insurance: insuranceReducer,
    leasing: leasingReducer,
    listWrapper: listWrapperReducer,
    locations: locationsReducer,
    mobile: mobileReducer,
    notifications: notificationsReducer,
    occupants: occupantsReducer,
    payments: paymentsReducer,
    properties: propertiesReducer,
    propertyTenantResolution: propertyTenantResolutionReducer,
    requests: requestsReducer,
    sales: salesReducer,
    settings: settingsReducer,
    spaces: spacesReducer,
    toastMessages: toastMessageReducer,
    users: usersReducer,
    welcome: welcomeReducer,
    invoices: invoicesReducer,
});

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
